import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { WatchComponent } from './components/watch.component'
import { WATCH_ANALYTICS_TAG } from './services/watch-analytics.service'

const routes: Routes = [
  {
    path: '',
    component: WatchComponent,
    data: {
      shouldShowEventTicker: false,
      /**
       * This property is set so we can prevent automatic page calls from being
       * made from App Component.
       *
       * @see outExcludedRoutes
       */
      segment: WATCH_ANALYTICS_TAG
    }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WatchRoutingModule {}
